import React, { useEffect, useRef } from "react";
import styles from "./RequestSuccessModal.module.scss";
import Modal from "sushiweb/Modal";
import lottie from "lottie-web"

function RequestSuccessModal({ visible, onClose }) {

  let animationContainerRef = useRef()
  let animationRef = useRef()
  
  useEffect(() => {
    animationRef.current = lottie.loadAnimation({
      container: animationContainerRef.current,
      path: "/assets/animations/feedback_confirmation.json", 
      renderer: "canvas",
      loop: false,
      autoplay: true,
    })

    return () => {
      animationRef.current.destroy()
    }
  }, [animationContainerRef.current, visible])

  useEffect(() => {
    let timer
    if (visible){
      timer = setTimeout(() => {
        onClose()
      }, 2500)
    } 
    return () => {
      timer && clearTimeout(timer)
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      type="default"
      isCentered
      slideOnMobile
      showCloseIcon={false}
      onClose={onClose}
    >
      <div className={styles.modalWrapper}>
        <div className={styles.successTick} ref={animationContainerRef} />
        <div className="text-align-center fs-30 text-black w-600">
          Request Submitted.
        </div>
        <div className="text-align-center fs-20 text-gray-900 w-400 mt-4 px-5">
          We’ll let you know when there’s an update
        </div>
      </div>
    </Modal>
  );
}

export default RequestSuccessModal;